/**
 * Etichetta di uno stato derivato («Unito», «Indesiderato», vedi
 * `displayStatus`) nelle viste operatore (tabella, card, dettaglio): piccola
 * icona al posto del pallino dello stato + testo, col tooltip. Colori in
 * support-v3.css (`.s3-dstat--*`, varianti .dark): testo >= 4.5:1, icona >= 3:1.
 */
import React from 'react';
import { Ban, GitMerge } from 'lucide-react';
import type { DisplayStatus } from './displayStatus';

const DerivedStatusMark: React.FC<{ d: DisplayStatus; size?: number }> = ({ d, size = 12 }) => {
  if (!d.derived) return null;
  const Icon = d.derived === 'merged' ? GitMerge : Ban;
  return (
    <span className={`s3-dstat s3-dstat--${d.derived}`} title={d.title} data-derived={d.derived}>
      <Icon size={size} strokeWidth={2.5} aria-hidden="true" focusable="false" />
      {d.label}
    </span>
  );
};

export default DerivedStatusMark;
